import React from 'react'
import {Icon} from '@chakra-ui/react'

const PlayIcon = (props) => {
    return (
        <Icon viewBox="0 0 29 29" {...props}>
            <g filter="url(#filter0_d_3043_1078)">
                <circle cx="14.5" cy="14.5" r="11.5" fill="white" />
            </g>
            <path
                d="M18.1375 13.677C18.5208 13.8984 18.5208 14.4516 18.1375 14.673L12.1 18.1587C11.7167 18.38 11.2375 18.1034 11.2375 17.6608L11.2375 10.6892C11.2375 10.2466 11.7167 9.96997 12.1 10.1913L18.1375 13.677Z"
                fill="#D11B59"
            />
            <defs>
                <filter
                    id="filter0_d_3043_1078"
                    x="0.7"
                    y="0.7"
                    width="27.6"
                    height="27.6"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.15" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_3043_1078"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_3043_1078"
                        result="shape"
                    />
                </filter>
            </defs>
        </Icon>
    )
}

export default PlayIcon
